export default __webpack_public_path__ + "2722a1f5d7ca17adce676581a899ff55.js";